var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddStylecolor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 378,
    height: 48,
    viewBox: "0 0 378 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "add-stylecolor",
    transform: "translate(-582.5 -803)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "btn-lg-secondary",
    transform: "translate(582.5 803)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "base",
    width: 378,
    height: 48,
    rx: 4,
    fill: "#2d639e"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Add_Choice_Style_Color",
    "data-name": "Add Choice Style Color",
    transform: "translate(20 31)",
    fill: "#fff",
    fontSize: 20,
    fontFamily: "ArialMT, Arial"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Add Choice Style Color"))), /*#__PURE__*/React.createElement("g", {
    id: "_icon",
    "data-name": "+ icon",
    transform: "translate(921.5 818)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_3",
    "data-name": "L\\xEDnea 3",
    y2: 19,
    transform: "translate(9.5)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_4",
    "data-name": "L\\xEDnea 4",
    y2: 19,
    transform: "translate(19 9.5) rotate(90)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddStylecolor);
export default __webpack_public_path__ + "static/media/add_stylecolor.36d73c6c6e7154f0dc3223bf584d766c.svg";
export { ForwardRef as ReactComponent };